import type { ChatMessage as ApiMessage } from '../../lib/api'
import { ChatMessage } from './ChatMessage'

export interface ChatMessageListProps {
  messages: ApiMessage[]
  isLoading?: boolean
  className?: string
}

export function ChatMessageList({
  messages,
  isLoading = false,
  className = '',
}: ChatMessageListProps) {
  return (
    <div
      className={`flex-1 overflow-y-auto overflow-x-hidden px-4 py-4 space-y-4 ${className}`}
      role="log"
      aria-label="Mensajes de la conversación"
    >
      {messages.length === 0 && !isLoading && (
        <div className="flex flex-col items-center justify-center h-full min-h-[200px] text-slate-500">
          <p className="text-sm">No hay mensajes aún.</p>
          <p className="text-xs mt-1">Escribe un mensaje para comenzar.</p>
        </div>
      )}
      {messages.map((msg) => (
        <ChatMessage key={msg.id} message={msg} />
      ))}
      {isLoading && (
        <div className="flex gap-3">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center">
            <span className="inline-block w-4 h-4 border-2 border-slate-400 border-t-transparent rounded-full animate-spin" />
          </div>
          <div className="bg-white border border-slate-200 rounded-2xl rounded-tl-sm px-4 py-3 shadow-sm">
            <div className="flex gap-1.5">
              <span className="w-2 h-2 rounded-full bg-slate-300 animate-bounce [animation-delay:0ms]" />
              <span className="w-2 h-2 rounded-full bg-slate-300 animate-bounce [animation-delay:150ms]" />
              <span className="w-2 h-2 rounded-full bg-slate-300 animate-bounce [animation-delay:300ms]" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
